export const RedFrown = (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
        <path
            fill="#FA5252"
            fillRule="evenodd"
            d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm1.43 5.498a9 9 0 0 0-5.4 1.35 1 1 0 1 1-1.06-1.696 11 11 0 0 1 6.6-1.65 1 1 0 0 1-.14 1.995Z"
            clipRule="evenodd"
        />
    </svg>
);
